import React from 'react';
import { Box } from '@mui/material';
import OrderServiceReportDashboard from '../../components/gerencia/report/orderService/OrderServiceReportDashboard';

const ReportesOrdenServicioPage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <OrderServiceReportDashboard
        onReorder={(newOrder) => {
          console.log('Nuevo orden de reportes para OS:', newOrder);
        }}
      />
    </Box>
  );
};

export default ReportesOrdenServicioPage;